import { render, staticRenderFns } from "./modalViewFile.vue?vue&type=template&id=0d828fba&scoped=true&"
import script from "./modalViewFile.vue?vue&type=script&lang=js&"
export * from "./modalViewFile.vue?vue&type=script&lang=js&"
import style0 from "./modalViewFile.vue?vue&type=style&index=0&id=0d828fba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d828fba",
  null
  
)

export default component.exports